import { Component, Input, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'cp-barchart',
    templateUrl: './cp-barchart.component.html',
    styleUrls: ['./cp-barchart.component.css'],
    standalone: false
})
export class CpBarchartComponent implements OnChanges {

  showTextDescription = true;
  percentInfo: number;
  @Input() infodescription: string;
  @Input() textdescription: string;
  @Input() percent: number;

  @ViewChild('cpinfo') cpinfo: ElementRef<HTMLInputElement>;
  @ViewChild('cptitle') cptitle: ElementRef<HTMLInputElement>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.percent) {

      if (typeof (this.cpinfo) !== 'undefined') {
        this.cpinfo.nativeElement.setAttribute('x', this.GetXpercent(4, 14, 82));
        this.cptitle.nativeElement.setAttribute('x', this.GetXpercent(4, 6, 85));
      }
      if (typeof (this.cptitle) !== 'undefined' && typeof (this.percent) !== 'undefined') {
        this.cptitle.nativeElement.textContent = this.percent.toString() + '%';
      }
      this.showTextDescription = this.percent < 80;
      this.percentInfo = this.percent > 98 ? 98 : this.percent;
    }
  }

  GetXpercent(startvalue: number, middlevalue: number, finalvalue: number): string {
    let perc = 0;
    if (typeof (this.percent) !== 'undefined') {
      perc = this.percent;
      if (perc > finalvalue) {
        perc = finalvalue;
      }
      else {
        if (perc < startvalue) {
          perc = startvalue;
        }
        else {
          if (perc > 20) {
            perc -= middlevalue;
          }
        }
      }
    }
    return perc.toString() + '%';
  }

}
